import platform from 'platform';

/**
 * Don't include "X" platform since other names include the character
 */
const IN_APP_BROWSERS = [
  'instagram',
  'linkedin',
  'messenger',
  'facebook',
  'twitter',
  'whatsapp',
  'discord',
  'mail',
  'telegram',
  'reddit',
  'meta',
];

export const isInAppBrowser = () => {
  const lowerCaseUA = platform.ua?.toLowerCase();

  const windowKeys = Object.keys(window);

  return (
    IN_APP_BROWSERS.find((browser) => lowerCaseUA?.includes(browser)) ||
    windowKeys.includes('TelegramWebview') ||
    windowKeys.includes('TelegramWebviewProxy') ||
    windowKeys.includes('setTelegramFontOverrides')
  );
};
